// extracted by mini-css-extract-plugin
module.exports = {"heading1":"FAQ_heading1__1eUex","accordianCss":"FAQ_accordianCss__3Akvz","accordiandiv":"FAQ_accordiandiv__2iXPo","accordianbody":"FAQ_accordianbody__e2Xsv"};